import { render } from "./AssetNotificationRulesView.vue?vue&type=template&id=2236bb83&ts=true"
import script from "./AssetNotificationRulesView.vue?vue&type=script&lang=ts"
export * from "./AssetNotificationRulesView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__